export default "__VITE_ASSET__B_WU9a$V__"